import { render } from "./StoreTag.vue?vue&type=template&id=d7018a88&scoped=true"
import script from "./StoreTag.vue?vue&type=script&lang=js"
export * from "./StoreTag.vue?vue&type=script&lang=js"

import "./StoreTag.vue?vue&type=style&index=0&id=d7018a88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7018a88"]])

export default __exports__